// src/utils/telemetry.ts

import { appConfig } from "../AppConfig/variables";

// ---- Unique ID helpers ----
function generateId() {
  return crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2);
}

// Persistent USER ID (stored forever unless user clears storage)
export function getUserId() {
  let userId = localStorage.getItem("telemetry_user_id");
  if (!userId) {
    userId = generateId();
    localStorage.setItem("telemetry_user_id", userId);
  }
  return userId;
}

// Persistent per-visit SESSION ID
export function getSessionId() {
  let sessionId = sessionStorage.getItem("telemetry_session_id");
  if (!sessionId) {
    sessionId = generateId();
    sessionStorage.setItem("telemetry_session_id", sessionId);
  }
  return sessionId;
}

const TELEMETRY_ENDPOINT = appConfig.env[appConfig.current_env].rest_api_host +
      "/global/telemetry";

// ---- Core Telemetry Sender ----
export async function logTelemetry(
  category,
  action,
  details = {}
) {
  const payload = {
    eventName: `${category}.${action}`,
    details,
    timestamp: new Date().toISOString(),
    page: window.location.pathname,
    userId: getUserId(),
    sessionId: getSessionId(),
  };

  try {
    await fetch(TELEMETRY_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch (err) {
    // if (process.env.NODE_ENV === "development") {
    //   console.warn("Telemetry failed:", err);
    // }
  }
}

// ---- Convenience Wrappers ----
export function trackPageView(pageName) {
  logTelemetry("PageView", pageName);
}

export function trackButtonClick(action, details) {
  logTelemetry("ButtonClick", action, details);
}

export function trackModalOpened(action, details) {
  logTelemetry("ModalOpened", action, details);
}

export function trackUserLoggedIn(action, details) {
  logTelemetry("UserLoggedIn", action, details);
}

export function trackFormSubmitted(action, details) {
  logTelemetry("FormSubmitted", action, details);
}

export function trackError(error, extra = {}) {
  logTelemetry("Error", error.name, {
    message: error.message,
    stack: error.stack,
    ...extra,
  });
}
